module.exports = __webpack_public_path__ + "media/images/athletes/1481-6bde8048feadf11024850279bc816370.png";